import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {PositionEffects} from './position.effects';
import {positionsFeatureKey, positionsReducer} from './position.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(positionsFeatureKey, positionsReducer),
    EffectsModule.forFeature([PositionEffects])
  ]
})
export class PositionStoreModule {

}
